import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import Bowser from 'bowser';
import errorBoundary from '@ifeng-fe/errorBoundary';
import FixBottom from '../../tfhoursmodel/layout/fixBottom';
import Content from '../../tfhoursmodel/layout/content/';
import { jsonp, Event } from '@ifeng-fe/ui_base';
import { h5PageCount } from 'ThreeTerminal_utils';
import { QQShare } from 'ThreeTerminal_mobile';

import { getTFHoursList } from '../../../services/api';

import FixTop from '../../tfhoursmodel/layout/fixTop';
import Banner from '../../tfhoursmodel/layout/banner';
import { handleTime } from '@ifeng-fe/container_channel/common/client/winter/mobile/utils/formatDate';
// import { getArrIndex } from '@ifeng-fe/container_channel/common/client/winter/mobile/utils/utils';
// import { rel } from '@ifeng-fe/container_channel/common/client/utils/rel';
import { handleAd } from '@ifeng-fe/container_channel/common/client/winter/utils/handleAd';
import styles from './index.css';

const refs = [];
let observer = {};

class Layout extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {
        curPage: 1,
        pageSize: 20, // sever default
        totalPage: null,
        newsList: [],
        isAjax: false,
        isEnd: false,
        banImg:
            (this.props.content.banner.length > 0 && this.props.content.banner[0].thumbnail) ||
            'https://p2.ifengimg.com/a80c2beeeff78280/2018/12/banner_v3.png',
        // for topTime
        scrollTop: 0,
        todayStr: `${new Date().getFullYear()}/${new Date().getMonth() + 1}/${new Date().getDate()}`,
        qqShareCofig: {},
    };

    event = new Event();

    insert = (insertArr, replaceArr, adFn) => {
        if (adFn && typeof adFn === 'function') {
            const { newsList } = this.state;
            const infoData = [...newsList];
            const refs = [];

            insertArr.forEach(item => {
                const ref = React.createRef();

                refs.push({ index: item, ref });

                infoData.splice(item, 0, { type: 'ad', ref });
            });

            replaceArr.forEach(item => {
                const ref = React.createRef();

                refs.push({ index: item, ref });

                infoData.splice(item, 1, { type: 'ad', ref });
            });

            this.setState(
                {
                    newsList: infoData,
                },
                () => {
                    const dom = {};

                    for (const ref of refs) {
                        dom[ref.index] = ref.ref.current;
                    }

                    adFn(dom);
                },
            );
        }

        return;
    };

    adInit = data => {
        try {
            this.event.trigger('init', data); // 触发广告位插入方法
        } catch (e) {
            console.error(e);
        }
    };

    async componentDidMount() {
        const { content } = this.props;

        // ad
        try {
            const callback = await handleAd(content.adNews);

            callback(content.adNews.data, this.event, this.insert);
        } catch (e) {
            console.error(e);
        }

        try {
            // 初始化 IntersectionObserver
            this.getIntersectionInit();

            // 获取第一页数据
            await this.getData();

            // 广告
            const newsList = this.state.newsList;
            const data = {
                len: newsList.length,
            };

            if (newsList) {
                this.adInit(data);
            }
        } catch (e) {
            console.error(e);
        }

        document.addEventListener('scroll', this.handleScrollMore.bind(this));

        // 上报首屏时间
        if (window && window.BJ_REPORT) window.BJ_REPORT.firstScreen();

        // page statistics
        h5PageCount([
            {
                datatype: content.isVideoShare ? 'vappsns_ex' : 'newsappsns',
                behavior: 'page',
                type: 'h5',
                other: {
                    id: '24h_newhour',
                    url: encodeURIComponent(location.href),
                },
            },
        ]);
    }
    componentWillUnmount() {
        try {
            if (observer) observer.disconnect();
            document.removeEventListener('scroll', this.handleScrollMore.bind(this));
        } catch (e) {
            console.error(e);
        }
    }

    addRefForTime(data) {
        const infoData = [...data];

        infoData.forEach((item, index) => {
            if (item.type === 'ad') {
                return;
            }

            const ref = React.createRef();
            const pageSize = this.state.pageSize;
            const curPage = this.state.curPage;
            const refIndex = pageSize * (curPage - 1) + index;

            if (!item.ref) {
                item.ref = ref;
            }
            refs.push({ index: refIndex, ref });
        });

        return infoData;
    }

    handleScrollMore() {
        const winH = window.innerHeight;
        const scrollH = document.body.scrollHeight;
        const scrollTop = document.body.scrollTop || document.documentElement.scrollTop || window.pageYOffset;
        const scrollBottom = scrollH - scrollTop;

        if (scrollBottom >= winH && scrollBottom <= winH + 50) {
            this.getData();
        }

        this.setState({
            scrollTop,
        });
    }

    getIntersectionInit() {
        try {
            if (IntersectionObserver) {
                observer = new IntersectionObserver(
                    entries => {
                        entries.forEach((item, index) => {
                            if (item.target.dataset.type === 'ad' || !item.target.dataset.time) {
                                return;
                            }
                            console.log(index, '<index>', item.intersectionRatio, '---intersectionRatio-');
                            console.log(item.target.dataset.time, '---item.target.dataset.time======');
                            console.log(item.target.dataset.title, '---item.target.dataset.title======');
                            const todayStr = handleTime(this.state.todayStr, 'ymd');
                            const scrollStr = item.target.dataset.time;

                            // console.log('item:', item);
                            console.log('isIntersecting:', item.isIntersecting);
                            console.log('todayStr :', todayStr);
                            console.log('scrollStr:', scrollStr);
                            // be carefull !!!
                            if (item.isIntersecting && todayStr && scrollStr && todayStr !== scrollStr) {
                                this.setState({
                                    todayStr: scrollStr,
                                });
                            }
                        });
                    },
                    {
                        threshold: 1.0,
                    },
                );
            }
        } catch (e) {
            console.error(e);
        }
    }

    getData = async () => {
        try {
            if (this.state.isAjax || this.state.isEnd) {
                return;
            }
            this.setState({
                isAjax: true,
            });

            const { curPage, pageSize } = this.state;
            const data = await getTFHoursList('75220', curPage, pageSize);

            if (!data.length) {
                this.setState({
                    isAjax: false,
                    isEnd: true,
                });

                return;
            }
            let newsList = [];
            let isEnd = this.state.isEnd;
            let todayStr = this.state.todayStr;

            const chConfig = {
                thumbnail: 'http://p2.ifengimg.com/ifengimcp/pic/20180521/8d47d96c7dbf7677620f_size111_w345_h228.png',
                shareThumbnail:
                    (this.props.content.banner.length > 1 && this.props.content.banner[1].thumbnail) ||
                    'http://p1.ifengimg.com/ifengimcp/pic/20180716/35fd69791a8d2a53f170_size37_w300_h300.jpg',
                desc: '新闻24小时',
                chid: '24h_newhour',
            };
            // const chConfig = data[0].chConfig;
            const title = chConfig.desc;

            newsList = data;
            // has more or not
            if (this.state.curPage === data[0].totalPage) {
                isEnd = true;
            }

            if (newsList[0].newsTime && todayStr !== newsList[0].newsTime) {
                todayStr = newsList[0].newsTime;
            }

            // create thresholdArr
            // newsList.forEach(item => {
            //     if (item.type === 'ad') {
            //         return;
            //     }
            //     thresholdArr.push(0.9);
            // });

            // init IntersectionObserver

            newsList = this.addRefForTime(newsList);

            const qqShareCofig = {
                title: `${title}|${newsList[0].title}`,
                img: chConfig.shareThumbnail || 'https://p1.ifengimg.com/29b92e35b2b20708/2017/51/ifengLogo300x300.jpg',
                desc: newsList[0].intro,
                cb: () => {},
            };

            this.setState(
                preState => ({
                    curPage: preState.curPage + 1,
                    totalPage: newsList.totalPage,
                    newsList: [...preState.newsList, ...newsList],
                    isEnd,
                    isAjax: false,
                    todayStr,
                    qqShareCofig: { ...this.state.qqShareCofig, ...qqShareCofig },
                }),
                () => {
                    newsList.forEach((item, index) => {
                        // console.log('item::', index, (item.type !== 'ad' && item.ref), item);
                        if (item.type !== 'ad' && item.ref) {
                            observer.observe(item.ref.current);
                        }
                    });
                },
            );
        } catch (e) {
            console.error(e);
        }
    };

    render() {
        const { newsList, scrollTop, todayStr, banImg, isAjax, isEnd, qqShareCofig } = this.state;
        const isLoading = isAjax ? <p className={styles.dataLoading}>数据加载中...</p> : null;
        const isAll = isEnd ? <p className={styles.dataAll}>已显示全部数据</p> : null;
        const domQQShare = qqShareCofig.title && <QQShare content={qqShareCofig} />;

        return (
            <Fragment>
                {/* 顶部时间 */}
                {todayStr &&
                    (scrollTop > 100 || scrollTop < 100) && (
                        <FixTop
                            scrollTop={scrollTop}
                            todayStr={todayStr.indexOf('-') > -1 ? todayStr.replace(/-/g, '/') : todayStr}
                        />
                    )}
                {/* banner */}
                {banImg && <Banner banImg={banImg} />}
                {/* 中间内容部部分 */}
                {newsList.length ? <Content contentData={newsList} /> : null}
                <div className={styles.statusBox}>
                    {isLoading}
                    {isAll}
                </div>
                {domQQShare}
                <FixBottom />
            </Fragment>
        );
    }
}

export default errorBoundary(Layout);
